import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import {
  FormElement,
  Select,
  SELECT_VARIANT_WITH_CHECKBOX,
  IconQuestion
} from 'mailup-web-components'
import { useRecoilCallback, useRecoilState, useRecoilValue } from 'recoil'
import { tagsListState } from '../../recoil/state/list'
import { messageState } from '../../recoil/state/message'
import { addNewTagCallback } from '../../recoil/callbacks/callbacks'
// OK -> Visibile solo se se uo:TAG == true && e co:TAG==true
// OK -> Selezione multipla
// OK -> Possibilità di creare nuovo tag
// OK -> API: BE Lists /api/tags (GET/POST)
// OK -> Differenze rispetto alla versione attuale
// OK -> Non ci sarà il link “Add new tag”, se si inserisce una voce non presente verrà aggiunta automaticamente all’elenco
// OK -> Utilizzare il componente https://dev-mailup-web-components.emailsp.info/?path=/story/react-elements-select-beta--auto-add

const InputTags = () => {
  const intl = useIntl()

  // item del tag list
  // CreationDate: "2019-05-24T09:54:49.02Z"
  // Enabled: true
  // Id: 8
  // IdList: 1
  // Name: string
  // UpdateDate: "2019-05-24T09:54:49.02Z"

  const makeOption = e => ({
    label: `${e.Name}`,
    value: e.Id,
    disabled: !e.Enabled
  })
  const addTagCallback = useRecoilCallback(addNewTagCallback, [])
  const { tagsList } = useRecoilValue(tagsListState)
  const [{ tags }, setTagsState] = useRecoilState(messageState)

  const options = tagsList.map(makeOption)

  const props = () => ({
    disabled: false,
    placeholder: intl.formatMessage({ id: 'Load.TagSelector.lblSelectTags' }),
    hint:
      (tags.length === options.length &&
        intl.formatMessage({ id: 'Load.Common.NoMoreOptions' })) ||
      null,
    onChange: value => {
      setTagsState(prev => ({
        ...prev,
        tags: value
      }))
    }
  })

  const handleSubmit = e => {
    const exist = tagsList.find(t => t.Name === e)
    if (!exist) {
      addTagCallback(e)
    }
  }

  return (
    <FormElement
      label={intl.formatMessage({ id: 'Load.SavedEmailWizard.TagSection' })}
      labelHelp={intl.formatMessage({
        id: 'Load.SavedEmailWizard.TooltipTags'
      })}
    >
      <Select
        variant={SELECT_VARIANT_WITH_CHECKBOX}
        options={options}
        {...props()}
        multiple
        value={tags}
        onSubmit={handleSubmit}
        data-mu-test='select-tags'
        placeholder={intl.formatMessage({
          id: 'Load.SavedEmailWizard.PlaceholderTags'
        })}
      />
    </FormElement>
  )
}

InputTags.propTypes = {
  onChange: PropTypes.func
}

export default InputTags
